@if (
  {
    isLoading: isLoading(),
    organizationData: organizationData(),
    currentError: currentError(),
    currentOrganization: currentOrganization$ | async
  };
  as STATE
) {
  <main class="organization-switcher-dialog">
    <custom-modal-card
      [enableClose]="!!STATE.currentOrganization"
      [isCloseDisabled]="STATE.isLoading"
    >
      <section header>
        <default-modal-header
          [title]="'Sélection de l\'organisation'"
          [description]="'Sélectionnez l\'organisation à consulter'"
        ></default-modal-header>
      </section>

      <section body>
        <form cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
          <mat-form-field>
            <mat-label>Rechercher une organisation</mat-label>
            <input
              matInput
              [formControl]="searchControl"
              cdkFocusInitial
              placeholder="Nom de l'organization"
            />
            <mat-hint align="end">
              Seules les organisations ayant terminés leur onboarding sont
              visibles
            </mat-hint>

            @if (searchControl.getError('httpError'); as error) {
              <mat-error>
                {{ error }}
              </mat-error>
            }
          </mat-form-field>
        </form>

        <ng-scrollbar>
          <div class="organization-switcher-dialog__items-wrapper">
            @if (STATE.isLoading || STATE.currentError) {
              <loading-or-error
                [error$]="currentError$"
                (retry)="organizationResource.reload()"
                loaderSize="lg"
              ></loading-or-error>
            }
            <!---->
            @else if (STATE.organizationData) {
              @for (
                organization of STATE.organizationData.items;
                track organization.id;
                let i = $index
              ) {
                <p
                  (click)="selectOrganization(organization)"
                  class="organization-switcher-dialog__item"
                >
                  {{ organization.name | titlecase }} <br />
                  NCC: <b>{{ organization.nif }}</b>
                </p>
              } @empty {
                <section class="empty-container empty-container--left-md">
                  <div class="empty-container__text">
                    <h1>Aucune organisation disponible</h1>
                  </div>
                </section>
              }
            }
          </div>
        </ng-scrollbar>
      </section>
    </custom-modal-card>
  </main>
}
